// Pick the smallest backend image variant that still covers a display box.
//
// `variants` is the API's smallest-first list: [{ w: 64, url }, …]. Given the
// CSS px the image renders at, we multiply by devicePixelRatio and return the
// first variant at least that wide — a 44 px glyph on a 2× screen fetches the
// 128 px file, not the 245 px original. Falls back to `fallback` when there are
// no variants (older backend).
export function pickVariant(variants, targetCssPx, fallback = null) {
  if (!Array.isArray(variants) || variants.length === 0) return fallback
  const dpr = (typeof window !== 'undefined' && window.devicePixelRatio) || 1
  const need = targetCssPx * dpr
  for (const v of variants) {
    if (v && v.w >= need) return v.url
  }
  return variants[variants.length - 1].url // nothing big enough → largest
}
